// @flow

import type {
  AuthState,
  RequestResetPasswordOperation,
} from '../../types'

export default function requestResetOperation (state: { auth: AuthState }): ?RequestResetPasswordOperation {
  return state.auth.requestResetOperation
}
